import { useState } from 'react';

interface SearchFiltersProps {
  onSearch: (filters: any) => void;
}

export default function SearchFilters({ onSearch }: SearchFiltersProps) {
  const [searchType, setSearchType] = useState('refundNo');
  const [searchValue, setSearchValue] = useState('');
  const [status, setStatus] = useState('');
  const [refundTimeRange, setRefundTimeRange] = useState({ start: '', end: '' });

  const handleSearch = () => {
    onSearch({
      searchType,
      searchValue,
      status,
      refundTimeRange
    });
  };

  const handleReset = () => {
    setSearchType('refundNo');
    setSearchValue('');
    setStatus('');
    setRefundTimeRange({ start: '', end: '' });
    onSearch({});
  };

  return (
    <div className="bg-white rounded-lg p-6 mb-6">
      <div className="grid grid-cols-4 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">搜索类型</label>
          <select
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
          >
            <option value="refundNo">售后单号/订单号</option>
            <option value="productName">商品名称</option>
            <option value="operatorId">操作用户ID</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">搜索内容</label>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder={searchType === 'productName' ? '支持模糊查询' : '仅精准查询'}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">售后状态</label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
          >
            <option value="">全部</option>
            <option value="退款成功">退款成功</option>
            <option value="退款失败">退款失败</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">退款时间</label>
          <div className="flex items-center gap-2">
            <input
              type="datetime-local"
              value={refundTimeRange.start}
              onChange={(e) => setRefundTimeRange({ ...refundTimeRange, start: e.target.value })}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm"
            />
            <span className="text-gray-500">至</span>
            <input
              type="datetime-local"
              value={refundTimeRange.end}
              onChange={(e) => setRefundTimeRange({ ...refundTimeRange, end: e.target.value })}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm"
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-3">
        <button
          onClick={handleReset}
          className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm hover:bg-gray-50 whitespace-nowrap"
        >
          重置
        </button>
        <button
          onClick={handleSearch}
          className="px-4 py-2 bg-teal-500 text-white rounded-lg text-sm hover:bg-teal-600 whitespace-nowrap"
        >
          搜索
        </button>
      </div>
    </div>
  );
}
